import { urlConst } from '../consts';
import { apiService } from './api.service';

export const programService = {
    getProgram
};

function getProgram(eventName = '', ts) {
    return apiService.get(`${urlConst.API_GET_PROGRAM}?event=${eventName}${ts ? '&ts=' + ts : ''}`);
}
